var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.editor }, [
    !_vm.activeSubModuleComponent
      ? _c(
          "div",
          {
            staticClass: "layout-column flex-center",
            class: _vm.$style.loader,
          },
          [_c("rbv-loading", { attrs: { label: "Loading, please wait..." } })],
          1
        )
      : _c(
          "span",
          [
            _c(
              "div",
              { class: _vm.getContentStyles() },
              [
                _vm.directory
                  ? _c(
                      _vm.activeSubModuleComponent,
                      _vm._b(
                        {
                          tag: "component",
                          attrs: {
                            expanded: !_vm.open,
                            directory: _vm.directory,
                          },
                          on: { preview: _vm.preview },
                        },
                        "component",
                        _vm.activeSubModule.props,
                        false
                      )
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "layout-column flex-center",
                        class: _vm.$style.loader,
                      },
                      [
                        _c("rbv-loading", {
                          attrs: { label: "Loading, please wait..." },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c("navigation", {
              attrs: { open: _vm.open, directory: _vm.directory },
              on: { toggle: _vm.toggleNavigator },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }